<template>
  <a-layout style="height: 100vh">
    <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible>
      <a-menu v-model:selectedKeys="selectedKeys" theme="dark" mode="inline">
        <a-menu-item key="userManage">
          <user-outlined/>
          <span>{{ $t("userManage") }}</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header id="components-layout-demo-custom-trigger" style="background: #fff; padding: 0">
        <menu-unfold-outlined
            v-if="collapsed"
            class="trigger"
            @click="() => (collapsed = !collapsed)"
        />
        <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)"/>
        <a-button style="position: absolute; right: 20px;top: 20px" @click="goHome">{{ $t("goHome") }}</a-button>
      </a-layout-header>
      <a-layout-content
          :style="{ margin: '8px 8px', padding: '8px', background: '#fff', minHeight: '280px', overflow:'auto' }"
      >
        <user-manage/>
      </a-layout-content>
    </a-layout>
  </a-layout>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/16 9:21
import {
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons-vue';
import VLoading from "@/components/public/v-loading";
import UserManage from "@/components/admin/userManage";

export default {
  name: "geneticAdmin",
  components: {
    UserManage,
    VLoading,
    UserOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
  },
  data() {
    return {
      loading: false,
      collapsed : false,
      selectedKeys : ['userManage'],
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    goHome(){
      this.$router.push("/home")
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {

    }
  }
}
</script>

<style scoped>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.3);
  margin: 16px;
}

.site-layout .site-layout-background {
  background: #fff;
}
</style>